import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navLinks } from "../mock";

const Logo = () => (
  <Link to="/" className="flex items-center gap-2 select-none">
    <span className="relative flex items-center justify-center w-11 h-11 rounded-xl bg-[#E23028] shadow-md">
      <span className="text-white font-extrabold text-2xl italic leading-none">S</span>
      <span className="absolute -right-1 top-1 w-2 h-2 rounded-full bg-white/80" />
    </span>
    <span className="flex flex-col leading-none">
      <span className="text-[#E23028] font-extrabold text-2xl tracking-tight">
        Spedy <span className="text-[#2b2b3a]">Fly</span>
      </span>
      <span className="text-[10px] tracking-[0.35em] text-[#7a7a85] font-medium mt-0.5">
        corriere expresso
      </span>
    </span>
  </Link>
);

const Header = () => {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`sticky top-0 z-50 bg-[#F6E8E8] border-b-2 border-[#E23028] transition-shadow duration-300 ${
        scrolled ? "shadow-md" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-5 md:px-8 h-[76px] flex items-center justify-between">
        <Logo />

        <nav className="hidden md:flex items-center gap-2">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.label}
                to={link.to}
                className={`px-4 py-2 rounded-md text-[15px] font-semibold tracking-wide transition-all duration-200 ${
                  active
                    ? "bg-[#E23028] text-white shadow-sm"
                    : "text-[#2b2b3a] hover:text-[#E23028]"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>

        <button
          className="md:hidden text-[#2b2b3a]"
          onClick={() => setOpen((o) => !o)}
          aria-label="Menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <nav className="md:hidden bg-[#F6E8E8] border-t border-[#E23028]/30 px-5 pb-4 flex flex-col gap-1">
          {navLinks.map((link) => {
            const active = location.pathname === link.to;
            return (
              <Link
                key={link.label}
                to={link.to}
                onClick={() => setOpen(false)}
                className={`px-4 py-3 rounded-md text-[15px] font-semibold tracking-wide ${
                  active ? "bg-[#E23028] text-white" : "text-[#2b2b3a]"
                }`}
              >
                {link.label}
              </Link>
            );
          })}
        </nav>
      )}
    </header>
  );
};

export default Header;
